import httpService from '@/services/httpService';
import ApiEndpoints from '@/utils/ApiEndpoints';

export default {
    postAuth (data) {
        return httpService.post(ApiEndpoints.get('authenticate'), data).then(({ data }) => {
            return httpService.get(ApiEndpoints.get('authentication_redirect', { token: data.token }));
        });
    },
    refreshToken () {
        return httpService.post(ApiEndpoints.get('refresh'));
    },
    logout () {
        return httpService.post(ApiEndpoints.get('logout'));
    }
};
